'use strict';
export default {
  methods: {
    verificarTarjeta (params) {
      return new Promise((resolve, reject) => {
        let respuesta = {
          tipo: 'error',
          mensaje: '',
          finalizado: false
        };
        this.$storage.set('token', process.env.TOKEN_EXTERNO);
        this.$service
        .post(`control_tarjeta/valida_tarjeta`, params)
        .then(response => {
          this.$storage.remove('token');
          if (response) {
            respuesta.finalizado = true;
            respuesta.mensaje = response;
            resolve(respuesta);
          } else {
            reject(respuesta);
          }
        })
        .catch(e => {
          this.$storage.remove('token');
          resolve(e);
          console.log(e);
        });
        this.$storage.remove('token');
      });
    },
    validarCorreo (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/portal/mixins/cuentas.js